import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=1df45d40&scoped=true&"
import script from "./BaseBanner.vue?vue&type=script&lang=ts&"
export * from "./BaseBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=1df45d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df45d40",
  null
  
)

export default component.exports